import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StudentAssignmentOverviewModel } from 'common/models/page-models/student-assignment-overview/student-assignment-overview-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentAssignmentOverviewWidgetService } from 'common/widget/students/student-assignment-overview-widget.service';

 
@Injectable({
    providedIn: 'root'
})
export class StudentAssignmentOverviewResolver extends FormResolverService<StudentAssignmentOverviewModel> {
    constructor(
        protected fs: StudentAssignmentOverviewWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // override modifyResponseData(dataModel) {
    //     dataModel['docPath'] = ''
       
    //     return dataModel;
    //   }
}